import React, { useState } from 'react';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { Popconfirm, Button, Icon, message } from 'antd';
import { readEvent, getDashboard } from './../API';

function ReadEventPopConfirm(props) {
  const session = useMappedState(state => state.session);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const reloadDashboard = async () => {
    const response = await getDashboard(session.authToken);

    if (response.data.responseCode === 0) {
      dispatch({ type: "INIT_DASHBOARD", payload: response.data.data });
    }
  }

  const handelOnClickEvent = async (i) => {
    setLoading(true);
    const result = await readEvent(session.authToken, { id: i.id });

    if (result.data.responseCode === 0) {
      await reloadDashboard();
      setLoading(false);
      message.success(result.data.message);
    }
    else {
      setLoading(false);
      dispatch({ type: "OPEN_MSG_MODAL", payload: result.data.message });
    }
  }

  return (
    <Popconfirm
      placement="left"
      title="Are you sure to tick this event?"
      onConfirm={() => handelOnClickEvent(props.event)}
      okText="Yes"
      cancelText="No"
    >
      <Button size="small">
        {
          loading ?
            <Icon type="loading" />
            :
            <Icon type="check" />
        }
      </Button>
    </Popconfirm>
  );
}

export default ReadEventPopConfirm;
